/**
 * Extract a user-facing error message from a thrown API error.
 *
 * The backend response envelope is `{ status, error, message, requestId }`
 * (see `apps/api/src/routes/*`), and axios surfaces that body on
 * `err.response.data`. We prefer that server-provided `message` when present,
 * fall back to a thrown `Error`'s own message, and finally to the caller's
 * generic fallback string.
 */
export function extractApiErrorMessage(err: unknown, fallback: string): string {
  if (err && typeof err === 'object' && 'response' in err) {
    const msg = (err as { response?: { data?: { message?: string } } }).response?.data?.message;
    if (msg) return msg;
  }
  if (err instanceof Error && err.message) return err.message;
  return fallback;
}
